"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pascalCase = void 0;
/**
 * Formats a given string to pascal format.
 * - If the input is null, it's returned null.
 * - If the input contain only one letter, it's returned capital letter of that.
 *
 * @param input - The input string.
 * @returns The formatted PascalCase string.
 */
const pascalCase = (input) => {
    if (!input)
        return input;
    const stringLength = input.length;
    if (stringLength == 1)
        return input.toUpperCase();
    input = input.split("_").join(" ");
    return (input.toLowerCase().charAt(0).toUpperCase() + input.toLowerCase().slice(1));
};
exports.pascalCase = pascalCase;
